/**
 * "Open *Record absence*" (#2029).
 *
 * The door is a button on the roster workspace toolbar — inline on a
 * desktop, in the phone's "•••" sheet, which unmounts as it closes — so the
 * small panel is mounted once by the app shell (`<RecordAbsenceHost/>`) and
 * opened through this store, the way *Fix and re-solve* is. The request
 * carries the team, the window the page opened on, and the dates on screen
 * (the panel's default day is today when it is on screen, else the first).
 */
import { create } from "zustand";

export interface RecordAbsenceRequest {
  teamId: string;
  /** The window the page opened on (the leave-review refresh is keyed on it). */
  cycleId: string;
  /** The dates on screen, inclusive ISO days. */
  dates: { from: string; to: string };
}

interface RecordAbsenceState {
  request: RecordAbsenceRequest | null;
  openRecordAbsence: (r: RecordAbsenceRequest) => void;
  closeRecordAbsence: () => void;
}

export const useRecordAbsenceStore = create<RecordAbsenceState>((set) => ({
  request: null,
  openRecordAbsence: (r) => set({ request: r }),
  closeRecordAbsence: () => set({ request: null }),
}));
